import { ApartmentStatus } from "../const";
import { IconLock } from "./IconLock";
import { IconUnlock } from "./IconUnlock";

export function ApartmentStatusIcon({ status }: { status: ApartmentStatus }) {
  return status === ApartmentStatus.Unlocked ? (
    <IconUnlock size={24} className="text-[#84ff97]" />
  ) : (
    <IconLock size={24} className="text-[#ff4e4e]" />
  );
}
